var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb"},[_c('InputText',{attrs:{"data-testid":"input","label":_vm.label,"value":_vm.value,"status":_vm.inputStatus,"required":_vm.required,"helper-text":_vm.error,"mask":_vm.mask},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }